import { OnboardingLangFactory } from "@bokio/lang";
import * as m from "@bokio/mobile-web-shared/core/model/model";
import { safeExhaustiveSwitch } from "@bokio/utils/safeExhaustiveSwitch";

import BokioUserExtendedTrialReasonCategory = m.Bokio.Common.Billing.Model.BokioUserExtendedTrialReasonCategory;

export const REASON_CATEGORIES_NEEDING_DETAILS = [
	BokioUserExtendedTrialReasonCategory.Other,
	BokioUserExtendedTrialReasonCategory.NoTimeToStart,
	BokioUserExtendedTrialReasonCategory.NotConvinced,
	BokioUserExtendedTrialReasonCategory.UsingCompetitor,
	BokioUserExtendedTrialReasonCategory.GotStuckOrNeededHelp,
];

export const getPlaceholderForReasonCategory = (reason: BokioUserExtendedTrialReasonCategory): string => {
	const onboardingLang = OnboardingLangFactory();
	return safeExhaustiveSwitch(
		() => {
			switch (reason) {
				case BokioUserExtendedTrialReasonCategory.NoTimeToStart:
					return onboardingLang.UserExtendedTrial_NoTimeToStart_Placeholder;
				case BokioUserExtendedTrialReasonCategory.NotConvinced:
					return onboardingLang.UserExtendedTrial_NotConvinced_Placeholder;
				case BokioUserExtendedTrialReasonCategory.UsingCompetitor:
					return onboardingLang.UserExtendedTrial_UsingCompetitor_Placeholder;
				case BokioUserExtendedTrialReasonCategory.GotStuckOrNeededHelp:
					return onboardingLang.UserExtendedTrial_GotStuckOrNeededHelp_Placeholder;
				case BokioUserExtendedTrialReasonCategory.Other:
					return onboardingLang.UserExtendedTrial_Other_Placeholder;
				case BokioUserExtendedTrialReasonCategory.NotReadyForAccountingSoftware:
					throw new Error(
						"NotReadyForAccountingSoftware should not happen because we get expected date separately (no placeholder)",
					);
				case BokioUserExtendedTrialReasonCategory.NotSet:
					throw new Error("NotSet should not happen");
			}
		},
		() => {
			throw new Error("Unknown BokioUserExtendedTrialReasonCategory");
		},
	);
};

export const getReasonOptions = () => {
	const onboardingLang = OnboardingLangFactory();
	return [
		{
			value: BokioUserExtendedTrialReasonCategory.NoTimeToStart,
			label: onboardingLang.UserExtendedTrial_Reason_NoTimeToStart,
		},
		{
			value: BokioUserExtendedTrialReasonCategory.NotReadyForAccountingSoftware,
			label: onboardingLang.UserExtendedTrial_Reason_NotReadyForAccountingSoftware,
		},
		{
			value: BokioUserExtendedTrialReasonCategory.NotConvinced,
			label: onboardingLang.UserExtendedTrial_Reason_NotConvinced,
		},
		{
			value: BokioUserExtendedTrialReasonCategory.UsingCompetitor,
			label: onboardingLang.UserExtendedTrial_Reason_UsingCompetitor,
		},
		{
			value: BokioUserExtendedTrialReasonCategory.GotStuckOrNeededHelp,
			label: onboardingLang.UserExtendedTrial_Reason_GotStuckOrNeededHelp,
		},
		{
			value: BokioUserExtendedTrialReasonCategory.Other,
			label: onboardingLang.UserExtendedTrial_Reason_Other,
		},
	];
};
